/* ------------------------------------------- */
/*   Queries for coordinator search
/* ------------------------------------------- */

import { AppConfig } from 'AppSrc/core/config/app-config';
import { getRESTQuery } from 'AppSrc/core/queries/axios-queries';

const COORDINATOR_GROUP_TYPE = '6000'; // id for changeUser
const ASSIGNMENT_APPROVAL_GROUP_TYPE = '7000'; // ID For assignment approval
// Get a list of coordinator groups for network type
// type: one of 'mobile' or 'fixed'
const getCoordinatorGroups = (network) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.groups.list}`;
  const params = {
    network,
    group_type: COORDINATOR_GROUP_TYPE,
  };
  return getRESTQuery(endpoint, params)
    .then((response) => response.data.results);
};

// Get a list of coordinators for network type and group id
// type: one of 'mobile' or 'fixed'
// groupId: the id of the user group
const getCoordinatorGroupMembers = (network, groupId, crqStatus) => {
  const endpoint = `${AppConfig.apiBaseUrl}${AppConfig.endpoints.groups.members}`;
  const params = {
    network,
    group_id: groupId,
    group_type: crqStatus === '5' ? ASSIGNMENT_APPROVAL_GROUP_TYPE : COORDINATOR_GROUP_TYPE, // For assignment approval, group_type should be 7000.
  };
  return getRESTQuery(endpoint, params)
    .then((response) => response.data.results);
};


export { getCoordinatorGroups, getCoordinatorGroupMembers };

